// httpService.ts

export type ApiResponse = {
  [key: string]: any;
};

class HttpService {
  private readonly baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private getFullUrl(endpoint: string): string {
    return `${this.baseUrl}${endpoint}`;
  }


  private async handleFetch(url: string, options: RequestInit): Promise<Response> {
    const response = await fetch(url, options);
    return response;
  }

  async get(endpoint: string, headers?: HeadersInit): Promise<any> {

    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, { method: 'GET', headers, credentials: 'include' });
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.statusText}`);
    }
    const data = (await response.json()) as ApiResponse;
    return data;
  }
  async post<ApiResponse>(
    endpoint: string,
    data: any,
    headers?: HeadersInit
  ): Promise<any> {
    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(await response.text());
    }
    const responseData = (await response.json()) as ApiResponse;
    return responseData;
  }

  async postCart(
    endpoint: string,
    data: any,
    headers?: HeadersInit
  ): Promise<any> {
    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.status;
  }

  async submitOrderPost<ApiResponse>(
    endpoint: string,
    data: any,
    headers?: HeadersInit
  ): Promise<any> {
    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw await response.json();
    }
    console.log('response===>', response)
    const responseData = (await response.json()) as ApiResponse;
    return responseData;
  }
  async put<ApiResponse>(
    endpoint: string,
    data: any,
    headers?: HeadersInit
  ): Promise<any> {

    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, {
      method: 'PUT',
      headers,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.statusText}`);
    }
    const responseData = (await response.json()) as ApiResponse;

    return responseData;
  }

  async delete<ApiResponse>(endpoint: string, headers?: HeadersInit): Promise<any> {

    const url = this.getFullUrl(endpoint);
    const response = await this.handleFetch(url, {
      method: 'DELETE',
      headers,
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.statusText}`);
    }
    const responseData = (await response.json()) as ApiResponse;

    return responseData;
  }

}

export default HttpService;
